import { useEffect, useState } from "react";
import { fetchBlogHomeCategories } from "../../api/GlobalApi";
import { Link } from "react-router-dom";

function Categories () {

    const [blogCategories, setBlogCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBlogHomeCategories()
        .then((data) => {
            setBlogCategories(Array.isArray(data) ? data : []);
            setLoading(false);
        })
        .catch(() => setLoading(false));
    }, []);

    if (loading)
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );

    return (
        <section class="section">
            <div class="section-header">
                <h2 class="section-title">Browse by topic</h2>
                <Link to="/blogs/categories" className="see-more">
                    See more
                </Link>
            </div>
            <div class="categories-grid">
                {blogCategories.slice(0, 6).map((category) => (
                    <Link to={`/blogs/category/${category.slug}`} key={category.id} className="category-card" style={{textDecoration: "none"}}>
                        <div className="category-icon" style={{
                            background: category.color,
                            backgroundImage: `url(${category.image_url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            boxShadow: `0 0 0 2px ${category.color}`
                            }}>

                        </div>
                        <div className="category-name">{category.name}</div>
                    </Link>
                ))}
            </div>
        </section>
    );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // full page center
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

// Add global keyframes for spinner
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`,
  styleSheet.cssRules.length
);

export default Categories;